module.exports = __webpack_public_path__ + "media/img/blue-swirl2-b72fc4e703472c74f449d756ebcb8734.svg";